import styled, { css } from 'styled-components';
import { UiColors } from 'assets/styles/old/global';
import { TOOLBAR_CONTROL_HEIGHT, TOOLBAR_CONTROL_RADIUS } from '../toolbarControl';

/* The track is the control, so IT carries the toolbar height — its segments fill what's left inside the
   padding. Previously the 34px segment height WAS the outer height plus the track's own padding and
   border, making the switcher 42px: 8px taller than every other control in the toolbars it sits in. */
export const Group = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: ${TOOLBAR_CONTROL_HEIGHT};
  box-sizing: border-box;
  padding: 3px;
  background: ${UiColors.cloudColor};
  border: 1px solid ${UiColors.strokeColor};
  border-radius: ${TOOLBAR_CONTROL_RADIUS};
  flex: 0 0 auto;

  /* Match the compact sort control height on narrow toolbars. */
  @media (max-width: 1023px) {
    padding: 2px;
  }
`;

export const Item = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  /* Fills the track rather than setting the outer height (see Group). */
  height: 100%;
  gap: 6px;
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  background: transparent;
  font-size: 14px;
  color: ${UiColors.forestColor};
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease;

  /* Hover preview on non-selected segments so it reads as a switchable toggle. */
  &:hover {
    background: ${UiColors.fillWhiteColor};
  }

  svg {
    width: 15px;
    height: 15px;
  }

  @media (max-width: 1023px) {
    gap: 4px;
    padding: 0 10px;
    font-size: 13px;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  ${({ active }) =>
    active &&
    css`
      background: ${UiColors.forestColor};
      color: ${UiColors.peachColor};
      font-weight: 600;

      &:hover {
        background: ${UiColors.forestColor};
      }
    `}
`;
